// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__o-Y87","noInteraction":"EventWrapper_noInteraction__2eNdK"};